// Sdílený backdrop pro modální dialogy.
//
// Řeší chybu, kdy se dialog zavřel při ukončení výběru textu mimo dialog:
// když uživatel začne označovat text uvnitř dialogu a myš pustí nad backdropem,
// prohlížeč pošle `click` na backdrop → `onClick={onClose}` dialog zavřel.
//
// Řešení: zavíráme jen když `mousedown` I `mouseup` proběhnou přímo na backdropu
// (ne na jeho obsahu). Výběr textu z dialogu tedy dialog nikdy nezavře.
//
// Použití:
//   <ModalOverlay onClose={onClose} className="z-50">
//     <div className="bg-white rounded-2xl …">…obsah…</div>
//   </ModalOverlay>
// Obsah NEpotřebuje `onClick={e => e.stopPropagation()}` — ModalOverlay to řeší sám.
import { useRef } from 'react'

export function ModalOverlay({ onClose, children, className = '', align = 'center' }) {
  // true jen dokud `mousedown` začal na backdropu samotném (ne v obsahu)
  const downOnBackdrop = useRef(false)

  const alignCls = align === 'top' ? 'items-start pt-16' : 'items-center'

  return (
    <div
      className={`fixed inset-0 bg-black/40 flex justify-center ${alignCls} ${className}`}
      onMouseDown={(e) => { downOnBackdrop.current = e.target === e.currentTarget }}
      onMouseUp={(e) => {
        if (downOnBackdrop.current && e.target === e.currentTarget) onClose?.()
        downOnBackdrop.current = false
      }}
    >
      {children}
    </div>
  )
}
